import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ViewProofDocumentModal = ({ open, onClose, data }) => {
  const [tab, setTab] = useState(0);

  const handleChange = (_, newValue) => {
    setTab(newValue);
  };

  const checkInFiles = data?.checkIN || [];
  const checkOutFiles = data?.checkOut || [];

  const filesToShow = tab === 0 ? checkInFiles : checkOutFiles;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          backdropFilter: "blur(10px)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            Uploaded Documents
          </Typography>
          <Typography variant="caption" color="text.secondary">
            View check-in & check-out proofs
          </Typography>
        </Box>

        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            bgcolor: "#f5f5f5",
            "&:hover": { bgcolor: "#e0e0e0" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={handleChange}
          sx={{
            mb: 2,
            "& .MuiTabs-indicator": {
              height: 3,
              borderRadius: 3,
              backgroundColor: "#1976d2",
            },
          }}
        >
          <Tab
            label={`Check In (${checkInFiles.length})`}
            sx={{
              textTransform: "none",
              fontWeight: 500,
            }}
          />
          <Tab
            label={`Check Out (${checkOutFiles.length})`}
            sx={{
              textTransform: "none",
              fontWeight: 500,
            }}
          />
        </Tabs>

        {/* Grid */}
        {filesToShow.length === 0 ? (
          <Box
            textAlign="center"
            py={6}
            sx={{
              color: "text.secondary",
            }}
          >
            <Typography variant="body1" fontWeight={500}>
              No documents found 📂
            </Typography>
            <Typography variant="caption">
              Upload proofs to see them here
            </Typography>
          </Box>
        ) : (
          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fill, minmax(140px, 1fr))"
            gap={2}
          >
            {filesToShow.map((item, i) => (
              <Box
                key={i}
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  position: "relative",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px) scale(1.03)",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                  },
                  "&:hover .overlay": {
                    opacity: 1,
                  },
                }}
                onClick={() => window.open(item.file, "_blank")}
              >
                <img
                  src={item.file}
                  alt="proof"
                  style={{
                    width: "100%",
                    height: 120,
                    objectFit: "cover",
                  }}
                />

                {/* Hover Overlay */}
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    bgcolor: "rgba(0,0,0,0.4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0,
                    transition: "0.3s",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: "#fff", fontWeight: 500 }}
                  >
                    View
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewProofDocumentModal;